export default __webpack_public_path__ + "media/components/Logo/logo-c84e7391699f0fcd83b988c7c664a6ce.svg";